<template>
  <div>
    <ul class="board-list" v-if="isJobs">
      <!-- <li v-for="item in list" :key="item.recruitNo" @click.prevent="$router.push({ name: 'CareerDetail', params: { recruitNo: item.recruitNo } })"> -->
      <li v-for="item in list" :key="item.recruitNo" @click.prevent="jobDetail($event, item.recruitNo)"
      :data-ga-category="gaEvent.category.career.jobs.name" :data-ga-label="gaEvent.category.career.jobs.label1" :data-ga-action="gaEvent.actions.jobDetail">
        <v-chip color="primary" :class="{ ing: item.showYn === 'Y' }"><span v-if="item.showYn">진행</span><span v-else>마감</span></v-chip>
        <dl>
          <dt>[{{ item.title }}]</dt>
          <dd>{{ item.subTitle }}</dd>
        </dl>
        <p>{{ item.subTitleContent }}</p>
      </li>
    </ul>
    <ul class="board-list" v-if="isNotice">
      <li v-for="item in list" :key="item.noticeNo" @click.prevent="$router.push({ name: 'NoticeDetail', params: { noticeNo: item.noticeNo } })">
        <dl class="ml-0">
          <dt>[{{ item.title }}]</dt>
          <dd>{{ item.content }}</dd>
        </dl>
        <p>
          <time :datetime="item.updDt">{{ moment(item.updDt).format("YYYY-MM-DD") }}</time>
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
import {GaTracking} from "@/mixins/index.js";
export default {
  mixins: [GaTracking],
  name: "BoardList",
  components: {},
  props: {
    list: {
      type: Array,
      default: function() {
        return [];
      }
    },
    category: {
      type: String,
      default: "jobs" //or "notice"
    }
  },
  data() {
    return {};
  },
  computed: {
    isNotice() {
      return this.category === "notice";
    },
    isJobs() {
      return this.category === "jobs";
    }
  },
  watch: {},
  methods: {
    jobDetail(e, recruitNo) {
      this.gaTracking(e);
      this.$router.push({ name: 'CareerDetail', params: { recruitNo: recruitNo } });
    }
  },
  created() {}
};
</script>

<style lang="scss" scoped>
.board-list {
  list-style: none;
  li {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    border-bottom: 1px solid #e5e5e5;
    padding: 24px 0;
    cursor: pointer;
    &:first-child {
      border-top: 1px solid #e5e5e5;
    }
    &:hover {
      background-color: #fafafa;
    }
    .v-chip {
      font-size: rem(11px);
      font-weight: 600;
      height: 20px;
      border-radius: 10px;
      margin-bottom: 8px;
      padding: 0 10px;
    }
    dl {
      display: block;
      margin-left: 0;
      font-size: rem(16px);
      letter-spacing: -1px;
    }
    p {
      font-size: rem(13px);
      color: #888888;
      margin-left: 0;
    }
  }
  @include respond-to("small") {
    li {
      padding: 24px 16px;
      .v-chip {
        font-size: rem(12px);
        height: 24px;
        border-radius: 12px;
        padding: 0 12px;
      }
      dl {
        display: flex;
        margin-left: 0;
        font-size: rem(18px);
        dt {
          margin-right: 8px;
        }
      }
      p {
        font-size: rem(14px);
      }
    }
  }
  @include respond-to("medium") {
    li {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 40px 32px 40px 0;
      cursor: pointer;
      .v-chip {
        font-size: rem(18px);
        height: 42px;
        border-radius: 21px;
        margin-bottom: 0;
        padding: 0 18px;
      }
      dl {
        display: flex;
        margin-left: 24px;
        font-size: rem(24px);
        dt {
          margin-right: 8px;
        }
      }
      p {
        font-size: rem(18px);
        margin-left: auto;
      }
    }
  }
}
</style>